import { fansupportPrivate } from "../index";
/**
 * Asynchronously deletes a team from a user's favorite teams list.
 *
 * @async
 * @function
 * @name getDeleteFavoriteTeam
 * @param {Object} options - An object containing the following properties:
 * @param {string} options.teamId - The ID of the team to delete from favorite teams.
 * @param {string} options.tournamentId - The ID of the tournament the team belongs to.
 * @return {Promise<Object>} A Promise that resolves to the server's response data.
 * @throws {Error} If an error occurs during the request.
 */
export const getDeleteFavoriteTeam = async ({ teamId, tournamentId }) => {
    try {
        const data = fansupportPrivate.delete('/sport/delete-favorite-team', {data: {
            teamId,
            tournamentId,
        }}) 
        return data;

    } catch (error) {
        console.log("getDeleteFavoriteTeam",error)
    }
}